import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Country } from "../models/country";

@Injectable({
  providedIn: "root",
})
export class CountryService {
  private readonly endpoint = "countries";
  private readonly baseUrl = environment.apiConfig.uri;
  private readonly endpointUrl: string;
  constructor(private readonly http: HttpClient) {
    this.endpointUrl = this.baseUrl + this.endpoint;
  }

  public getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(this.endpointUrl);
  }
}
